import { HCF } from "@macashipo/mlib"
import { HApi, HAuth, HConfig } from "../helpers"
import { parseLangConfig } from "../helpers/i18n"
import ModuleCheckIdle from "src/modules/check_idle"

interface IModuleFirstSetting extends ICore.IOneModule {
  getQueryFirstSetting: () => object
  requestFirstSetting: () => void
  parseFirstSetting: (data: object) => void
}
const ModuleFirstSetting: IModuleFirstSetting = {
  _key: "first_setting",
  _fnList: {},
  _config: {},
  getMyKey: () => {
    return "first_setting"
  },
  runAfterInit: (HConfig: any) => {
    ModuleFirstSetting.requestFirstSetting()
  },
  getQueryFirstSetting: () => {
    let qr: any = {
      UI_LangBundles: HCF.getCF("defaultLangBundles"),
    }
    if (!HAuth.authIsLogged()) {
      qr.LangCodeBrowser =
        window.navigator["userLanguage"] || window.navigator.language
    }
    return qr
  },
  requestFirstSetting: () => {
    HApi.apiPost({
      path: "GlobalAppSetting",
      name: "FisrtSetting",
      data: ModuleFirstSetting.getQueryFirstSetting(),
    })
      .then(response => {
        if (response.Data) {
          ModuleFirstSetting.parseFirstSetting(response.Data)
        }
      })
      .catch(error => {})
  },
  parseFirstSetting: data => {
    if (data) {
      HCF.setCFMultiObj(data)
      if (data["DefaultValues"]) {
        HCF.setCFMultiObj(data["DefaultValues"])
        if (data["DefaultValues"]["configAutoLogout"]) {
          HCF.setCFMultiObj(data["DefaultValues"]["configAutoLogout"])
        }
      }
      if (data["LangConfig"]) {
        parseLangConfig(data["LangConfig"])
      }
      let _fnWaiting = HCF.getCF("waitingFirstSettingForLanguage")
      if (_fnWaiting) {
        _fnWaiting()
      }
      ModuleCheckIdle.runAfterInit(HConfig)
      //xu ly language
      // update language neu co thay doi version
      //
      // console.warn(i18next.getDataByLanguage("en"))
    }
  },
}

export default ModuleFirstSetting
